import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { DashboardService } from '../../services/dashboard/dashboard.service';
@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {
  @Input() backgroundColorip: any;
  @Input() dataip: any;
  @Input() labelsip: any;

  public chart: any = null;
  data: any
  constructor(
    private dashboardService: DashboardService
  ) {
    dashboardService._getSARevenueSummaryChartObserver.subscribe(res => {
      this.dataip = res;
      this.renderChart()

    })
    dashboardService._getSARevenueSummaryCharLablesObserver.subscribe(res => {
      this.labelsip = res
      this.renderChart()

    })
  }
  ngOnInit() {
  }
  renderChart() {

    this.chart ? this.chart.destroy() : ''

    this.data = {
      labels: this.labelsip,
      datasets: [
        {
          label: 'Dataset 1',
          data: this.dataip,
          backgroundColor: this.backgroundColorip,
        }
      ]
    };

    this.chart = new Chart('pie', {
      type: 'pie',
      data: this.data,
      options: {
        responsive: true,
        legend: {
          position: 'right',
          labels: {
            usePointStyle: true
          }
        },
      },
    });
  }
}
